import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SapFicoParameterService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SapFicoParameterCreateDto,
  SapFicoParameterDto,
  SapFicoParameterExcelDownloadDto,
  SapFicoParameterUpdateDto,
} from '../proxy/controlling/dtos/sap-fico-parameter';
import { SAPFICOPARAMETER_CONFIG, SAPFICOPARAMETER_FIELDS } from './sap-fico-parameter.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sap-fico-parameter',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapFicoParameterService, ConfirmationService],
  templateUrl: './sap-fico-parameter.html',
  styleUrl: './sap-fico-parameter.scss',
})
export class SapFicoParameter extends BaseHierarchicalCrudComponent<
  SapFicoParameterDto,
  SapFicoParameterCreateDto,
  SapFicoParameterUpdateDto,
  SapFicoParameterExcelDownloadDto
> {
  service = inject(SapFicoParameterService);
  config = SAPFICOPARAMETER_CONFIG;
  fields = SAPFICOPARAMETER_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapFicoParameterDto): SapFicoParameterUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SapFicoParameter';
  }
}
